const ACTIVE = 'Active';
const CUSTOMER_UNRESPONSIVE = 'Customer Unresponsive/Customer Interference';
const DEACTIVATED = 'Deactivated';
const DEAL_CANCELLED = 'Deal Cancelled';
const DEAL_CANCELLED_DUE_TO_CREDIT = 'Deal Cancelled due to credit';
const FAILED_DEACTIVATION = 'Failed Deactivation';
const INACTIVE = 'Inactive';
const PTO_GRANTED = '10. PTO Granted, Facility Active';
const PURCHASED_SYSTEM = 'Customer Purchased System';
const RECOVERED = 'PTO Granted, Facility Active - Recovered';
const PROMOTIONAL = 'PTO Granted, Facility Active - Promotional';
const ASSET_IMPAIRED_PENDING_REMOVAL = 'Asset Impaired Pending-Removal';
const ASSET_IMPAIRED_PENDING_BILLABLE = 'Asset Impaired Pending-Billable';
const REMOVAL_TEMPORARY_CUSTOMER_FAULT = 'Removal-Temporary (Customer fault)';
const REMOVAL_TEMPORARY_SUNRUN_FAULT = 'Removal-Temporary (Sunrun fault)';

export {
  ACTIVE,
  CUSTOMER_UNRESPONSIVE,
  DEACTIVATED,
  DEAL_CANCELLED,
  DEAL_CANCELLED_DUE_TO_CREDIT,
  FAILED_DEACTIVATION,
  INACTIVE,
  PTO_GRANTED,
  PURCHASED_SYSTEM,
  RECOVERED,
  PROMOTIONAL,
  ASSET_IMPAIRED_PENDING_REMOVAL,
  ASSET_IMPAIRED_PENDING_BILLABLE,
  REMOVAL_TEMPORARY_CUSTOMER_FAULT,
  REMOVAL_TEMPORARY_SUNRUN_FAULT,
};
